<template>
  <v-navigation-drawer temporary absolute :value="drawer">
    <v-list nav>
      <v-list-item-group>
        <v-list-item v-for="(item,index) in menuItems" :key="index" link :to="item.url" active-class="active">
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// import { MDCList } from "@material/list";
import { mapState, mapMutations } from 'vuex';

export default {
  name: "MDCDrawer",

  computed: {
    ...mapState({
      drawer: state => state.globals.drawer,
    }),
  },

  mounted() {
    // new MDCList(document.querySelector(".mdc-list"));
  },

  data: function () {
    return {
      menuItems: [
        {
          title: "Home",
          url: "/",
          icon: "home",
        },
        {
          title: "Cliff",
          url: "/brand/cliff",
          icon: "web",
        },
        {
          title: "Force",
          url: "/brand/force",
          icon: "home",
        },
        {
          title: "Classic Milano",
          url: "/brand/classic-milano",
          icon: "home",
        },
        {
          title: "Focus",
          url: "/brand/focus",
          icon: "home",
        },
        {
          title: "Contact",
          url: "/contact/",
          icon: "phone",
        },
        {
          title: "About",
          url: "/about/",
          icon: "web"
        },
      ],
    };
  },

  methods: {
    ...mapMutations({
      SET_DRAWER: "SET_DRAWER",
    }),
  },
};
</script>

<style lang="scss" scoped>
</style>
